import $ from "jquery";

const $doc = $(document);
const DEBOUNCE_MS = 350;
const MIN_CHARS = 2;

/**
 * Desktop search panel — open/close + live AJAX results
 */
function initDesktopSearch() {
  const $toggle = $(".js-search-toggle");
  const $panel = $("#site-search");
  const $close = $(".js-search-close");
  const $input = $("#site-search-input");
  const $results = $(".js-search-results");

  if (!$toggle.length || !$panel.length) return;

  // Read config passed from PHP via wp_localize_script
  const config = window.AirportSearch || {};
  const hasAPI = !!(config.ajax_url && config.nonce);

  let debounceTimer = null;
  let abortController = null;

  // ── Panel open / close ──────────────────────────────────────

  function openSearch() {
    $panel.removeAttr("hidden");
    $toggle.attr("aria-expanded", "true");
    $input.trigger("focus");
  }

  function closeSearch() {
    $panel.attr("hidden", "");
    $toggle.attr("aria-expanded", "false");
    $toggle.trigger("focus");
    // Clear results when closing
    clearResults();
    $input.val("");
  }

  $toggle.on("click", function () {
    const isOpen = $toggle.attr("aria-expanded") === "true";
    if (isOpen) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  $close.on("click", closeSearch);

  $doc.on("keydown", function (e) {
    if (e.key === "Escape" && !$panel.is("[hidden]")) {
      closeSearch();
    }
  });

  // ── Live search ─────────────────────────────────────────────

  if (!hasAPI || !$results.length) return;

  function clearResults() {
    $results.empty();
  }

  function showLoading() {
    $results.html(
      '<p class="site-search__loading" role="status">Searching&hellip;</p>'
    );
  }

  function showNoResults(query) {
    $results.html(
      '<p class="site-search__no-results" role="status">No results found for &ldquo;' +
        escapeHtml(query) +
        '&rdquo;</p>'
    );
  }

  function showError() {
    $results.html(
      '<p class="site-search__no-results" role="status">Something went wrong. Please try again.</p>'
    );
  }

  function escapeHtml(str) {
    const div = document.createElement("div");
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /**
   * Render grouped search results into the results container.
   * Uses data.grouped (pre-sorted by PHP) so ordering matches the search results page.
   */
  function renderResults(data, query) {
    // Use the pre-sorted grouped data from PHP
    var grouped = data.grouped;
    if (!grouped || !Object.keys(grouped).length) {
      showNoResults(query);
      return;
    }

    let html = "";

    Object.keys(grouped).forEach(function (typeKey) {
      var group = grouped[typeKey];

      html +=
        '<div class="site-search__section">' +
        '<h3 class="site-search__section-title">' +
        escapeHtml(group.label) +
        "</h3>";

      group.items.forEach(function (item) {
        const url = item.url || "#";
        const title = item.title || "";
        const excerpt = item.excerpt || "";

        html +=
          '<a href="' +
          escapeHtml(url) +
          '" class="site-search__result">' +
          '<span class="site-search__result-title">' +
          escapeHtml(title) +
          "</span>";

        if (excerpt) {
          // Excerpt contains <mark> tags from PHP — trust it
          html +=
            '<span class="site-search__result-excerpt">' +
            excerpt +
            "</span>";
        }

        html += "</a>";
      });

      html += "</div>";
    });

    // "View all results" link
    html +=
      '<a href="/?s=' +
      encodeURIComponent(query) +
      '" class="site-search__view-all">View all results</a>';

    $results.html(html);
  }

  /**
   * Perform the AJAX search request
   */
  function doSearch(query) {
    // Cancel any in-flight request
    if (abortController) {
      abortController.abort();
    }

    showLoading();

    // Use AbortController if available, otherwise let it ride
    if (typeof AbortController !== "undefined") {
      abortController = new AbortController();
    }

    $.ajax({
      url: config.ajax_url,
      type: "POST",
      data: {
        action: "airport_live_search",
        search_term: query,
        nonce: config.nonce,
      },
      beforeSend: function (jqXHR) {
        // Wire up abort if we have a controller
        if (abortController) {
          abortController.signal.addEventListener("abort", function () {
            jqXHR.abort();
          });
        }
      },
      success: function (response) {
        if (response.success && response.data) {
          renderResults(response.data, query);
        } else {
          showNoResults(query);
        }
      },
      error: function (jqXHR, textStatus) {
        // Don't show error for aborted requests
        if (textStatus === "abort") return;
        showError();
      },
    });
  }

  // Debounced input handler
  $input.on("input", function () {
    const query = $.trim($input.val());

    clearTimeout(debounceTimer);

    if (query.length < MIN_CHARS) {
      clearResults();
      return;
    }

    debounceTimer = setTimeout(function () {
      doSearch(query);
    }, DEBOUNCE_MS);
  });

  // Form submit — trigger immediate search instead of page navigation
  $panel.find("form").on("submit", function (e) {
    e.preventDefault();
    const query = $.trim($input.val());
    if (query.length >= MIN_CHARS) {
      clearTimeout(debounceTimer);
      doSearch(query);
    }
  });
}

export default function initSearch() {
  initDesktopSearch();
}
